import { bindGridSwiper } from './grid-swiper';
import './utils/legacy-showtime-runtime';

const LOADING_LABEL = 'đang tải...';

window.bindGridSwiper = bindGridSwiper;
window.bindGridSlick = bindGridSwiper;

document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
        const regionBtn = e.target.closest('.btn-choose-region');
        if (regionBtn) {
            e.preventDefault();
            doChooseRegion(regionBtn.dataset.region);
            return;
        }

        const cinemaBtn = e.target.closest('.btn-choose-cinema');
        if (cinemaBtn) {
            e.preventDefault();
            doChooseCinema(cinemaBtn.dataset.cinema);
            return;
        }

        const dateBtn = e.target.closest('#showtimes #dates .date');
        if (dateBtn) {
            e.preventDefault();
            params.date = dateBtn.dataset.date;

            if (!dateBtn.classList.contains('active')) {
                document.querySelectorAll('#dates .date').forEach(el => el.classList.remove('active'));
                dateBtn.classList.add('active');
                doGetShowtimes();
            }
        }
    });

    document.body.addEventListener('change', function (e) {
        if (e.target.matches('.btn-select-region')) {
            e.preventDefault();
            doChooseRegion(e.target.value);
            return;
        }

        if (e.target.matches('.btn-select-cinema')) {
            e.preventDefault();
            doChooseCinema(e.target.value);
        }
    });

    // Lần tải đầu: khôi phục khu vực VÀ rạp đã nhớ (nếu có).
    doChooseRegion(getRegion(), true);
});

// `restoreStored` chỉ bật ở lần tải trang đầu, khi ta khôi phục khu vực đã nhớ. Người
// dùng tự bấm/chọn khu vực thì để mặc định false: mở rạp đầu tiên của khu vực vừa chọn.
window.doChooseRegion = function (region, restoreStored = false) {
    document.querySelectorAll('.btn-select-region').forEach(el => {
        el.value = region;
    });
    document.querySelectorAll('.btn-choose-region').forEach(el => el.classList.remove('active'));
    const activeRegionBtn = document.querySelector('.btn-choose-region[data-region="' + region + '"]');
    if (activeRegionBtn) activeRegionBtn.classList.add('active');

    doGetCinemas(region, restoreStored);
}

window.doChooseCinema = function (cinema) {
    if (params.id !== cinema) {
        document.querySelectorAll('.btn-select-cinema').forEach(el => {
            el.value = cinema;
        });
        document.querySelectorAll('.btn-choose-cinema').forEach(el => el.classList.remove('active'));
        const activeCinemaBtn = document.querySelector('.btn-choose-cinema[data-cinema="' + cinema + '"]');
        if (activeCinemaBtn) activeCinemaBtn.classList.add('active');

        params.id = cinema;
        setCinema(params.id);
        doGetShowtimes();
    }
}

// MVK-3407 — danh sách rạp theo tỉnh là fragment Twig của moveek-web (RegionController::showtimeCinemasFragment),
// không còn tự dựng từ JSON moveek-api. Fragment chứa sẵn cả danh sách (nhóm theo cụm rạp) lẫn <option>; thứ tự trong
// đó là thứ tự hiển thị, phần tử đầu là "rạp đầu tiên của tỉnh/thành đang chọn" mà MVK-2951 lấy làm mặc định.
window.doGetCinemas = function (region, restoreStored = false) {
    const blockEl = document.getElementById('blockCinemas');
    let url = blockEl.dataset.cinemasUrl.replace('__ID__', encodeURIComponent(region));
    if (params.ticketing === 1) {
        url += '?ticketing=1';
    }

    setRegion(region);
    const listEl = document.querySelector('#blockCinemas .list');
    const selectEl = document.querySelector('#blockCinemas .btn-select-cinema');
    if (listEl) listEl.innerHTML = '<div class="text-center pt-4 pb-4"> <div class="text-muted spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
    if (selectEl) selectEl.innerHTML = '<option value="">' + LOADING_LABEL + '</option>';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(r => r.text())
        .then(function (html) {
            const fragment = document.createElement('template');
            fragment.innerHTML = html;
            const list = fragment.content.querySelector('[data-role="list"]');
            const options = fragment.content.querySelector('[data-role="options"]');

            if (listEl) listEl.innerHTML = list ? list.innerHTML : '';
            if (selectEl) selectEl.innerHTML = options ? options.innerHTML : '';

            // `data-cinema` là external_id (UUID), cùng dạng id API cũ mà cookie rạp đã lưu.
            const cinemaIds = Array.from(fragment.content.querySelectorAll('[data-role="list"] [data-cinema]'))
                .map((el) => el.dataset.cinema);
            doAutoSelectCinema(cinemaIds, restoreStored);
        });

    return false;
}

window.doGetShowtimes = function () {
    const showtimesEl = document.getElementById('showtimes');
    if (params.id) {
        if (showtimesEl) showtimesEl.innerHTML = '<div class="text-center mb-3"> <div class="text-muted spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
        fetch(generateRouteUrl('orn_web_cinema_showtime', {id: params.id, date: params.date, header: params.header}))
            .then(r => r.text())
            .then(function (data) {
                if (showtimesEl) showtimesEl.innerHTML = data;
                doGetShowtimePrice(data);
                appendUtmToAffiliateLinks();
            });
    } else {
        if (showtimesEl) showtimesEl.innerHTML = '<div class="alert alert-light">Bạn chưa chọn rạp.</div>';
    }
}

// MVK-2951: người dùng mới vào /mua-ve/ (hoặc /lich-chieu/) chưa có cookie rạp nên cột
// lịch chiếu trống trơn. Mặc định mở rạp đầu tiên của tỉnh/thành đang chọn.
//
// KHÔNG đối chiếu cookie với danh sách rạp để đoán rạp cũ thuộc tỉnh nào: cookie có HAI
// hệ id. Trang chi tiết rạp ghi `cinema.id` (số nguyên của Doctrine), còn danh sách ở
// đây lấy `id` của API = `external_id` (UUID) và API không trả kèm id số. Rạp nhớ từ
// trang chi tiết sẽ luôn "không có trong danh sách" và bị thay oan. Cả hai dạng đều chạy
// được vì route orn_web_cinema_showtime nhận cả UUID lẫn id số (CinemaController::showtime).
//
// Vì vậy phân biệt theo NGỮ CẢNH tải danh sách, đúng cho cả hai hệ id:
//   - `restoreStored` (lần tải đầu): còn nhớ rạp nào thì mở lại rạp đó.
//   - đổi khu vực: luôn mở rạp đầu tiên của khu vực vừa chọn.
window.doAutoSelectCinema = function (availableCinemaIds, restoreStored) {
    const cinema  = getCinema();
    const cinemas = Array.isArray(availableCinemaIds) ? availableCinemaIds : [];

    // Trang chi tiết rạp không render cột chọn rạp: nó tự set params.id + cookie rồi gọi
    // doGetShowtimes(). Cookie khu vực ở đó có thể trỏ tỉnh khác, tự ý mặc định sẽ ghi đè
    // lịch chiếu của chính rạp đang mở. Giữ nguyên hành vi cũ.
    if (! document.getElementById('blockCinemas')) {
        if (cinema !== '') {
            doChooseCinema(cinema);
        }
        return;
    }

    if (restoreStored && cinema !== '') {
        doChooseCinema(cinema);
        return;
    }

    if (cinemas.length > 0) {
        doChooseCinema(cinemas[0]);
        return;
    }

    // Khu vực chưa có rạp nào: bỏ lịch chiếu của rạp khu vực cũ, để doGetShowtimes()
    // hiện "Bạn chưa chọn rạp." thay vì giữ nội dung lạc đề.
    params.id = '';
    doGetShowtimes();
}
